import { Chip, TextField, makeStyles } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import React, { useEffect, useState } from "react";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  autocompleteInput: {
    "& .MuiOutlinedInput-root": {
      minHeight: 40,
      height: 40,
      borderRadius: 4,
      fontSize: "0.85rem",
      backgroundColor: "rgba(255, 255, 255, 0.03)",
      transition: "border-color 0.2s, box-shadow 0.2s",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      "&:hover": {
        borderColor: `${theme.palette.primary.main}80`,
      },
      "&.Mui-focused": {
        boxShadow: `0 0 8px ${theme.palette.primary.main}40`,
      },
    },
    "& .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"]": {
      padding: "2px 8px !important",
      minHeight: 40,
      height: 40,
      boxSizing: "border-box",
    },
    "& .MuiAutocomplete-inputRoot[class*=\"MuiOutlinedInput-root\"] .MuiAutocomplete-input": {
      padding: "2px 4px !important",
      fontSize: "0.85rem",
    },
    "& .MuiOutlinedInput-input": {
      padding: "6px 8px !important",
      fontSize: "0.85rem",
    },
    "& .MuiAutocomplete-popupIndicator": {
      padding: "4px !important",
    },
    "& .MuiAutocomplete-clearIndicator": {
      padding: "4px !important",
    },
  },
  tagChip: {
    margin: 1,
    fontSize: "0.68rem",
    height: 22,
    fontWeight: "bold",
    color: "#fff",
    textShadow: "0 1px 2px rgba(0,0,0,0.8)",
  }
}));

export function TagsFilter({ onFiltered, kanban, tagsystem, placeholder }) {
  const classes = useStyles();
  const [tags, setTags] = useState([]);
  const [selecteds, setSelecteds] = useState([]);

  useEffect(() => {
    async function fetchData() {
      await loadTags();
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kanban, tagsystem]);

  const loadTags = async () => {
    try {
      const params = {};
      if (kanban !== undefined && kanban !== null) params.kanban = kanban;
      if (tagsystem !== undefined && tagsystem !== null) params.tagsystem = tagsystem;

      const { data } = await api.get(`/tags/list`, { params });
      setTags(Array.isArray(data) ? data : []);
    } catch (err) {
      toastError(err);
    }
  };

  const onChange = async (value) => {
    const safeVal = value || [];
    setSelecteds(safeVal);
    onFiltered(safeVal);
  };

  return (
    <Autocomplete
      multiple
      size="small"
      options={tags}
      value={selecteds}
      onChange={(e, v) => onChange(v)}
      getOptionLabel={(option) => (typeof option === "string" ? option : option?.name || "")}
      style={{ width: "100%" }}
      renderTags={(value, getTagProps) =>
        value.map((option, index) => (
          <Chip
            key={index}
            variant="outlined"
            className={classes.tagChip}
            style={{
              backgroundColor: (typeof option === "object" && option?.color) ? option.color : "#00b4d8",
            }}
            label={typeof option === "string" ? option : option?.name || ""}
            {...getTagProps({ index })}
            size="small"
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          label={i18n.t("tickets.advancedFilters.filterContactTags") || "Etiquetas de Contacto"}
          InputLabelProps={{ shrink: true }}
          placeholder={selecteds.length === 0 ? (placeholder || i18n.t("tickets.advancedFilters.filterContactTagsPlaceholder") || "Seleccionar etiquetas de contacto...") : ""}
          className={classes.autocompleteInput}
        />
      )}
    />
  );
}
